import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from '../../../../app.main.component';
import { CategoryService } from './category.service';
import { ProductService } from '../product.service';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { ObjectNames, Status, Severity,Answer} from '../../constants/constants';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  providers: [ConfirmationService, DatePipe]
})
export class CategoryComponent implements OnInit {

  allInvenCategories = [];
  allInvenCateDropdown = [];
  productInventoryGroup: any;
  expandedRowsCate: {} = {};
  displayProductAvailability: boolean = false;
  associatedProducts: any;
  inventoryCategoryForm: FormGroup;
  selectedInvenCategory;
  displayAddEditCategory: boolean = false;
  isSubChildCatEdit: boolean = false;
  isChildCatEdit: boolean = false;
  isChildSubChildCatEdit: boolean = false;
  isParentCatEdit: boolean = false;
  selectedCategory = [];
  allRates = [];
  addEditCategoryHeader: string;
  addEditChildClassHeader;
  addEditSubClassHeader;
  displayAddEditChildClass: boolean = false;
  displayAddEditSubClass: boolean = false;
  statusConstants=Status;
  answertypeConstants=Answer;
  action: string='';
  categoryConstants= ObjectNames.productConstants;
  invalidData:boolean=false;

  constructor(
    private fb: FormBuilder,
    private app: AppMainComponent,
    private catService: CategoryService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private productconfigService: ProductService,
    private yearPipe: AddYearPipe,
    private titleCasePipe: TitleCasePipe
  ) { }

  ngOnInit(): void {

    this.productconfigService.getProductCategory().subscribe(cat => {
      ////console.log(cat)
      if (cat) {
        this.showAddCategory();
      }
    })
    this.inventoryCategoryForm = this.fb.group({
      id: [0],
      name: ['', [Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      organizationId: [this.app.companyId],
      isDefault: [false],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date().toISOString()],
      updatedBy: [this.app.companyId],
      updatedDate: [new Date().toISOString()],
      updatedSource: [this.app.userIP],
      description: [''],
      parentCategoryId: [0],
      statusId: [true],
      groupId: [''],
      typeId: [5],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.yearPipe.transform(new Date())]
    });
    this.getInventoryGroups();

  }

  getInventoryGroups() {
    this.catService.getInventoryGroupList().subscribe(groups => {
      this.productInventoryGroup = groups.filter(s => s.name == ObjectNames.productConstants.productCategoryName)[0];
      this.getInventoryCategory(this.productInventoryGroup.id);
    });
  }

  getInventoryCategory(groupId) {
    this.catService.getInventoryCategoryList(groupId).subscribe(cats => {
      if(cats){
      ////console.log(cats)
      this.allInvenCategories = cats;

      const thisRef = this;
      this.allInvenCategories.forEach(function (c) {
        thisRef.expandedRowsCate[c.id] = true;
      });
      this.expandedRowsCate = Object.assign({}, this.expandedRowsCate);

      let CateData = []
      for (let children of cats) {

        let childrenData = []
        for (let sub of children.childCategory) {
          sub.toggle = true;
          sub.subExpanded = true;

          let subData = []
          for (let subb of sub.childCategory) {
            subb.toggle = true;
            subb.subExpanded = true;

            if (subb.statusId == Status.ACTIVE) {
              let eachSub = {
                label: subb.name,
                value: subb.id,
                children: []
              }
              subData.push(eachSub)
            }

          }

          if (sub.statusId == Status.ACTIVE) {
            let eachChildItem = {
              label: sub.name,
              value: sub.id,
              children: subData
            }
            childrenData.push(eachChildItem)
          }

        }

        if (children.statusId == Status.ACTIVE) {
          let eachItem = {
            label: children.name,
            value: children.id,
            children: childrenData
          }
          CateData.push(eachItem)
        }

      }
      this.allInvenCateDropdown = JSON.parse(JSON.stringify(CateData));
      ////console.log(this.allInvenCateDropdown);
      }
    });
  }

  checkAssociateProduct(c, type, child?, subChild?, childSubChild?) {
    const deleteId = (type == ObjectNames.productConstants.parentType ? c.id : type == ObjectNames.productConstants.childType ? child.id : type == ObjectNames.productConstants.subChildType ? subChild.id : childSubChild.id)
    this.catService.checkProductAvailability(deleteId).subscribe(check => {
      if (!check.item1) {
        this.displayProductAvailability = true;
        this.action = 'delete';
        this.associatedProducts = check.item2;
      } else {
        if (type == ObjectNames.productConstants.parentType) {
          this.delClass(c);
        } else if (type == ObjectNames.productConstants.childType) {
          this.deleteChildClass(c, child);
        } else if (type == ObjectNames.productConstants.subChildType) {
          this.deleteSubClass(c, child, subChild);
        } else {
          this.deleteChildSubClass(c, child, subChild, childSubChild);
        }

      }
    })
  }

  delClass(c) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Category?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.catService.deleteClass(c.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allInvenCategories.indexOf(c);
          this.allInvenCategories.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  deleteChildClass(c, s) {
    ////console.log(s);
    this.confirmationService.confirm({
      message: 'Do you want to delete this Child Category?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.catService.deleteClass(s.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          c.childCategory.splice(c.childCategory.findIndex(function (i) {
            return i.id === s.id;
          }), 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  deleteSubClass(c, s, t) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Sub Class?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.catService.deleteClass(t.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          s.childCategory.splice(s.childCategory.findIndex(function (i) {
            return i.id === t.id;
          }), 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  deleteChildSubClass(c, s, t, p) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Sub Class?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.catService.deleteClass(p.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          t.childCategory.splice(t.childCategory.findIndex(function (i) {
            return i.id === p.id;
          }), 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  showEditCategory(c, type?) {
    this.isChildCatEdit = false;
    this.isSubChildCatEdit=false;
    this.invalidData = false;
    this.isChildSubChildCatEdit=false;
    ////console.log(c);
    this.addEditCategoryHeader = ObjectNames.productConstants.EditCategoryTitle;
    this.isParentCatEdit = true;
    this.inventoryCategoryForm.patchValue(c);
    const status = c.statusId == Status.ACTIVE ? true : false;
    this.inventoryCategoryForm.get("statusId").setValue(status);
    if (c.parentCategoryId > 0 && type == ObjectNames.productConstants.childType) {
      this.isChildCatEdit = true;
      const filteredParentCategory = this.allInvenCategories?.filter(cat => cat.id == c.parentCategoryId)[0];
      this.inventoryCategoryForm.get("parentCategoryId").setValue(filteredParentCategory);
      ////console.log(filteredParentCategory);
    } else if (c.parentCategoryId > 0 && type == ObjectNames.productConstants.subChildType) {
      this.isSubChildCatEdit = true;
      this.allInvenCategories.forEach(element => {
        element.childCategory.forEach(el => {
          if (el.id == c.parentCategoryId) {
            this.selectedCategory = element;
            const filteredParentCategory = el;
            ////console.log(el)
            this.inventoryCategoryForm.get("parentCategoryId").setValue(filteredParentCategory);
          }
        });
      })

    } else if (c.parentCategoryId > 0 && type == ObjectNames.productConstants.childSubChildType) {
      this.isChildSubChildCatEdit = true;
      this.allInvenCategories.forEach(element => {
        element.childCategory.forEach(el => {
          el.childCategory.forEach(els => {
            if (els.id == c.parentCategoryId) {
              this.selectedCategory = el;
              const filteredParentCategory = els;
              ////console.log(el)
              this.inventoryCategoryForm.get("parentCategoryId").setValue(filteredParentCategory);
            }
          });
        });
      })
    }

    this.displayAddEditCategory = true;
  }

  showAddCategory() {
    this.addEditCategoryHeader = ObjectNames.productConstants.AddCategoryTitle;
    this.invalidData = false;
    this.displayAddEditCategory = true;
    this.isChildCatEdit = false;
    this.isSubChildCatEdit = false;
    this.isChildSubChildCatEdit = false;
    this.inventoryCategoryForm = this.fb.group({
      id: [0],
      name: ['', [Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      organizationId: [this.app.companyId],
      isDefault: [false],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date().toISOString()],
      updatedBy: [this.app.companyId],
      updatedDate: [new Date().toISOString()],
      updatedSource: [this.app.userIP],
      description: [''],
      parentCategoryId: [0],
      statusId: [true],
      groupId: [''],
      typeId: [5],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.yearPipe.transform(new Date())]
    });
  }

  checkCategoryProduct() {
    if (this.isParentCatEdit && !this.inventoryCategoryForm.controls['statusId'].value) {
      this.catService.checkProductAvailability(this.inventoryCategoryForm.controls['id'].value).subscribe(check => {
        if (!check.item1) {
          this.displayProductAvailability = true;
          this.action = 'status';
          this.associatedProducts = check.item2;
          this.inventoryCategoryForm.get("statusId").setValue(true);
        } else {
          return;
        }
      })
    }
  }

  addEditCate(value) {
    value.description = value.name;
    value.groupId = this.productInventoryGroup.id;
    value.statusId = value.statusId == false ? Status.INACTIVE : Status.ACTIVE;
    value.updatedDate = new Date().toISOString();
    if (this.addEditCategoryHeader == ObjectNames.productConstants.AddCategoryTitle) {
      const lowerCaseNames = [];
      if(value.parentCategoryId==0){
        for (let s of this.allInvenCategories) {
          lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }
      }else{
        for (let s of value.parentCategoryId.children) {
          lowerCaseNames.push(s.label.toLowerCase().replace(/ /g, ''))
        }
      }
      if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
      } else {
        if ((value.parentCategoryId && value.parentCategoryId.value) > 0 && !this.isParentCatEdit) {
          value.parentCategoryId = value.parentCategoryId.value;
        } else {
          value.parentCategoryId = (value.parentCategoryId && value.parentCategoryId.id);
        }
        this.catService.addInventoryCategory(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Category Added successfully...' });
          this.getInventoryCategory(this.productInventoryGroup.id);
          this.displayAddEditCategory = false;
        }).catch(() => {
          this.displayAddEditCategory = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    } else {
      var duplicateRecord;
      if(value.parentCategoryId==0 || value.parentCategoryId==null){
         duplicateRecord = this.allInvenCategories.find(depOb => depOb.name.toLowerCase() == value.name.toLowerCase() && depOb.id !== value.id)
      }else{
         duplicateRecord = value.parentCategoryId.childCategory.find(depOb => depOb.name.toLowerCase() == value.name.toLowerCase() && depOb.id !== value.id)
      }
      if (duplicateRecord) {
        this.invalidData = true;
      } else {
        this.invalidData = false;
      }
      if ((value.parentCategoryId && value.parentCategoryId.value) > 0 && !this.isParentCatEdit) {
        value.parentCategoryId = value.parentCategoryId.value;
      } else {
        value.parentCategoryId = (value.parentCategoryId && value.parentCategoryId.id);
      }

      if(!this.invalidData){
        this.catService.updateInventoryCategory(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Category Updated successfully...' });
          this.getInventoryCategory(this.productInventoryGroup.id);
          this.displayAddEditCategory = false;
        }).catch(() => {
          this.displayAddEditCategory = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }

    }
    this.productconfigService.setProductCategory('');
  }

  closeAddEditCategory(){
    this.productconfigService.setProductCategory('');
    this.displayAddEditCategory = false;
  }

}
